<template>
  <div class="text-center">
    <v-dialog persistent v-model="roleModalOpen" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">{{roleData}}</v-card-title>

        <v-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeModal()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    roleModalOpen() {
      return this.$store.state.general.openRoleDialog;
    },
    roleData() {
      return this.$store.state.general.roleName;
    }
  },

  methods: {
    closeModal() {
      // this.roleData = false;
      this.$store.commit("general/setModal", { roleDialog: false });
    }
  }
};
</script>